import React, { useState, useRef, useCallback, useEffect } from "react";
import classnames from "classnames";
import styles from "@/styles/ExpandText.module.scss";

const ExpandText = ({ className, children, onClick }) => {
  const [more, setMore] = useState(false);
  const [open, setOpen] = useState();
  const containerRef = useRef();
  const textRef = useRef();
  const toggle = useCallback(() => {
    setOpen(!open);
    if (typeof onClick == "function") {
      onClick();
    }
  }, [open]);

  useEffect(() => {
    if (typeof open === "undefined") {
      const containerHeight = containerRef.current.clientHeight;
      const textHeight = textRef.current.clientHeight;
      if (containerHeight < textHeight) {
        setMore(true);
      } else {
        setMore(false);
      }
      setOpen(false);
    }
  }, [open, containerRef.current, textRef.current]);

  return (
    <div
      className={classnames(
        styles["expand-text"],
        { [styles.open]: open === true, [styles.withMore]: more },
        className
      )}
      ref={containerRef}
    >
      <div ref={textRef}>
        {React.Children.map(children, (child, i) =>
          React.cloneElement(child, {
            className: classnames({
              [styles.firstNode]: i == 0,
              [styles.ellipsis]: open === false && i == 0,
              [styles.otherNode]: i > 0,
            }),
          })
        )}
      </div>
      {more && (
        <div
          className={classnames(styles.showMoreBtn, {
            [styles.open]: open === true,
          })}
        >
          <button onClick={toggle}>
            {open === true ? "元に戻す" : "もっと詳しく"}
          </button>
        </div>
      )}
    </div>
  );
};

export default ExpandText;
